/* eslint-disable no-unused-vars */
import React from 'react'
import { Plus, X } from 'lucide-react'

import { Page } from '../../../components/layouts/page'
import { Column } from '../../../components/layouts/columns'
import { Icon } from '../../../components/icons'
import { Input } from '../../../components/ui/input'
import { Button } from '../../../components/ui/button'
import { useClientAddUsers } from './_hooks/useClientAddUsers'
import { Form } from '../../../components/ui/form'
import { Table } from '../../../components/ui/table'

export const AdminClientAddUsers = () => {
  const {
    loading,
    formContext,
    setFormContext,
    search,
    setSearch,
    dataContext,
    FetchGetData,
    HandleAddUser,
    HandleEditUser,
    HandleDeleteUser,
  } = useClientAddUsers()

  return (
    <Page.Section className="is-fullheight-with-navbar  mt-6 pt-6">
      <Column.Root>
        <Column.Content>
          <p className="subtitle is-size-3">Adicionar Usuários</p>
        </Column.Content>
        <Column.Content>
          <Button.Root align="right">
            <Button.Content>
              <Button.Bt
                className=""
                color={`${!formContext?.openModal ? `is-success` : `is-danger`}`}
                colorText="has-text-white"
                action={() => {
                  setFormContext((prev) => ({
                    ...prev,
                    openModal: prev?.openModal ? !prev?.openModal : true,
                  }))
                }}
                loading={loading}
              >
                {!formContext?.openModal ? <Plus /> : <X />}
              </Button.Bt>
            </Button.Content>
            <Button.Content>
              <Button.Bt
                color="is-dark"
                colorText="has-text-white"
                action={async () => {
                  await FetchGetData()
                }}
                loading={loading}
              >
                <Icon size={15}>sync</Icon>
              </Button.Bt>
            </Button.Content>
          </Button.Root>
        </Column.Content>
      </Column.Root>

      {/* Barra de pesquisa */}
      <Column.Root className="is-mobile">
        <Column.Content>
          <Input.Root>
            <Input.Contents alignIcon={'left'}>
              <Input.Prompt value={search} setValue={setSearch} placeholder="Pesquisar..."></Input.Prompt>
              <Input.Icon align="is-left">
                <Icon size={20}>search</Icon>
              </Input.Icon>
            </Input.Contents>
          </Input.Root>
        </Column.Content>
      </Column.Root>
      {formContext.openModal && (
        <Column.Root className="box">
          <Column.Content>
            <Form.Root>
              <Input.Root>
                <Column.Root>
                  <Column.Content>
                    <Input.Contents alignIcon={'left'}>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required>
                        Nome:
                      </Input.Label>
                      <Input.Prompt value={formContext} field={'user_name'} setValue={setFormContext}></Input.Prompt>
                    </Input.Contents>
                  </Column.Content>
                  <Column.Content>
                    <Input.Contents alignIcon={'left'}>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required>
                        CPF:
                      </Input.Label>
                      <Input.Prompt
                        maskSetValue="cpf"
                        maskValue="cpf"
                        value={formContext}
                        field={'user_cpf'}
                        setValue={setFormContext}
                      ></Input.Prompt>
                    </Input.Contents>
                  </Column.Content>
                </Column.Root>
                <Column.Root>
                  <Column.Content>
                    <Input.Contents alignIcon={'left'}>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required>
                        E-mail:
                      </Input.Label>
                      <Input.Prompt
                        value={formContext}
                        field={'user_email'}
                        type="email"
                        setValue={setFormContext}
                      ></Input.Prompt>
                    </Input.Contents>
                    <Input.Contents alignIcon={'left'}>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required>
                        Cargo
                      </Input.Label>
                      <Input.Prompt value={formContext} field={'user_role'} setValue={setFormContext}></Input.Prompt>
                    </Input.Contents>
                    <Input.Contents alignIcon={'left'}>
                      <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }} required>
                        Senha:
                      </Input.Label>
                      <Input.Prompt
                        value={formContext}
                        type="password"
                        field={'user_password'}
                        setValue={setFormContext}
                      ></Input.Prompt>
                    </Input.Contents>
                  </Column.Content>
                </Column.Root>
              </Input.Root>
              <Column.Content size="is-2">
                <Button.Bt
                  color="is-light"
                  className="mt-5"
                  type="submit"
                  action={async () => {
                    await HandleAddUser()
                  }}
                  loading={loading}
                >
                  Adicionar
                </Button.Bt>
              </Column.Content>
            </Form.Root>
          </Column.Content>
        </Column.Root>
      )}
      <Column.Root className="">
        <Column.Content>
          <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered ">
            <Table.Head>
              <Table.Row>
                <Table.Cell>Nome</Table.Cell>
                <Table.Cell>E-mail</Table.Cell>
                <Table.Cell>Cargo</Table.Cell>
                <Table.Cell>Setor</Table.Cell>
                <Table.Cell>Ações</Table.Cell>
                {/* <Table.Cell>Ações</Table.Cell> */}
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {(dataContext?.usersClient || []).map((value) => {
                return (
                  <>
                    <Table.Row key={value.id}>
                      <Table.Cell className="is-size-7 is-vcentered">{value.nome}</Table.Cell>
                      <Table.Cell className="is-size-7 is-vcentered">{value.email}</Table.Cell>
                      <Table.Cell className="is-size-7 is-vcentered">{value.cargo}</Table.Cell>
                      <Table.Cell className="is-size-7 is-vcentered">{value.sectorId}</Table.Cell>
                      <Table.Cell className="is-vcentered">
                        <div style={{ marginBottom: 5, marginTop: 5 }}>
                          <Button.Root align="centered">
                            <Button.Content>
                              <Button.Bt
                                action={async () => {
                                  await HandleEditUser(value.id)
                                }}
                                size="is-small"
                                color="is-warning"
                                loading={loading}
                              >
                                <Icon size={15}>pen</Icon>
                              </Button.Bt>
                            </Button.Content>
                            <Button.Content>
                              <Button.Bt
                                size="is-small"
                                color="is-danger"
                                action={() => {
                                  HandleDeleteUser(value.id)
                                }}
                                loading={loading}
                              >
                                <Icon size={15}>trash</Icon>
                              </Button.Bt>
                            </Button.Content>
                          </Button.Root>
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  </>
                )
              })}
            </Table.Body>
          </Table.Root>
        </Column.Content>
      </Column.Root>
    </Page.Section>
  )
}
